import React from 'react';

function About() {
  const features = [
    { icon: '🎓', title: 'Experienced Faculty', desc: '50+ highly qualified professors and clinical instructors' },
    { icon: '🏥', title: 'Modern Labs', desc: 'Advanced simulation labs and clinical training facilities' },
    { icon: '📚', title: 'Updated Curriculum', desc: 'Industry-aligned curriculum with hands-on training' },
    { icon: '🌍', title: 'Global Recognition', desc: 'INC, Karnataka Nursing Council & RGUHS affiliated' },
    { icon: '💼', title: '100% Placement', desc: 'Dedicated placement cell with top hospital partnerships' },
    { icon: '🏆', title: 'Govt. Recognized', desc: 'Recognized by Government of Karnataka' },
  ];

  return (
    <section id="about" className="about-section">
      <div className="section-container">
        <div className="section-title-block">
          <h2 className="section-title">
            <span className="title-icon">ℹ️</span> About Paramananda College of Nursing
          </h2>
          <div className="gold-underline"></div>
        </div>
        
        <div className="about-content">
          <div className="about-text">
            <h3>Excellence in Nursing Education — Bengaluru</h3>
            <p>
              Paramananda College of Nursing (PCN), located in Bengaluru, Karnataka, is a premier
              institution dedicated to nurturing skilled nurses for a healthier tomorrow. Affiliated
              with Rajiv Gandhi University of Health Sciences (RGUHS) and recognized by the
              Indian Nursing Council (INC), Karnataka Nursing Council, and K.S.D.N.E.B., Bangalore,
              we provide comprehensive education that combines theoretical knowledge with
              practical clinical experience.
            </p>
            <p>
              Our state-of-the-art campus at Veerabhadreshwara Nagara, Herohalli Village, Bengaluru
              features modern simulation labs, a well-stocked library, comfortable study environments,
              and strong hospital tie-ups for clinical training. We believe in nurturing compassionate,
              skilled, and ethical healthcare professionals ready to meet global healthcare challenges.
            </p>
            <div className="about-highlights">
              <div className="highlight">
                <span className="highlight-number">20+</span>
                <span>Partner Hospitals</span>
              </div>
              <div className="highlight">
                <span className="highlight-number">100%</span>
                <span>Placement Support</span>
              </div>
              <div className="highlight">
                <span className="highlight-number">3</span>
                <span>Nursing Programmes</span>
              </div>
            </div>
          </div>
          <div className="about-image">
            <div className="about-image-wrapper" style={{ border: '4px solid var(--gold)', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 12px 35px rgba(26,58,107,0.2)' }}>
              <img src="/college-building.jpeg" alt="Paramananda College of Nursing Campus" className="about-college-img" style={{ display: 'block', width: '100%', height: 'auto' }} />
            </div>
          </div>
        </div>
        
        <div className="features-grid" style={{ marginTop: '50px' }}>
          {features.map((feature, index) => (
            <div key={index} className="feature-card" style={{ border: '1px solid #e2e8f0', boxShadow: '0 4px 15px rgba(26,58,107,0.08)' }}>
              <span className="feature-icon" style={{ background: 'var(--primary-lighter)', color: 'var(--primary)', padding: '15px', borderRadius: '50%', display: 'inline-block', marginBottom: '15px' }}>{feature.icon}</span>
              <h4 style={{ color: 'var(--primary)' }}>{feature.title}</h4>
              <p style={{ fontSize: '0.85rem', color: 'var(--gray)' }}>{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default About;